import styled from "styled-components";

export const SolutionIconImg = styled.img`
  height: 1rem;
  width: 1rem;
`;
